<template>
	<div class="bg-white border rounded-lg p-4">
		<div class="mb-4">
			<h6 class="text-lg uppercase tracking-wider text-gray-500 mb-1">
				Discount spatiere
			</h6>
			<v-label class="text-base">
				Discount aplicat pe fiecare modul, in functie de spatierea aleasa in configurator.
			</v-label>
		</div>

		<v-form v-model="validForm" ref="formGapRates" @submit.prevent="save">
			<div class="flex flex-wrap gap-2">
				<v-text-field v-for="gap in gapKeys" :key="gap" v-model="rates[gap]" class="w-36 flex-grow-0" dense
					type="number" min="0" max="100" step="0.5" hide-spin-buttons outlined :label="labels[gap]"
					suffix="%" :rules="[rules.required, rules.percent]"></v-text-field>
			</div>

			<div class="flex justify-end">
				<v-btn type="submit" color="teal" class="uppercase white--text" :loading="saving"
					:disabled="saving || !hasChanges">Salveaza</v-btn>
			</div>
		</v-form>
	</div>
</template>

<script>
import pricingSection from './pricingSection';

export default {
	name: "GapRates",
	mixins: [pricingSection],
	data() {
		return {
			validForm: false,
			gapKeys: ['none', 'small', 'medium', 'large'],
			labels: {
				none: 'Fara spatiu',
				small: 'Spatiu mic',
				medium: 'Spatiu mediu',
				large: 'Spatiu mare'
			},
			rates: {},
			rules: {
				required: value => (value !== '' && value !== null && value !== undefined) || 'Câmp obligatoriu',
				percent: value => (!isNaN(parseFloat(value)) && parseFloat(value) >= 0 && parseFloat(value) <= 100) || 'Valoare intre 0 si 100',
			},
		};
	},
	computed: {
		saving() {
			return this.section.savingPricingConfig;
		},
		gapRates() {
			return this.section.pricingConfig.gapRates;
		},
		hasChanges() {
			const payload = this.buildPayload();
			return this.gapKeys.some(gap => payload[gap] !== this.gapRates[gap]);
		}
	},
	methods: {
		// the API stores fractions ([0, 1]), the form shows percentages
		syncFromStore() {
			const rates = {};
			this.gapKeys.forEach(gap => {
				rates[gap] = Math.round((this.gapRates[gap] || 0) * 10000) / 100;
			});
			this.rates = rates;
		},
		buildPayload() {
			const payload = {};
			this.gapKeys.forEach(gap => {
				payload[gap] = Number((parseFloat(this.rates[gap]) / 100).toFixed(4));
			});
			return payload;
		},
		async save() {
			const valid = await this.$refs.formGapRates.validate();

			if (valid) {
				// full replace of the column, all four keys are always sent
				this.dispatchSection('savePricingConfig', { gapRates: this.buildPayload() });
			}
		}
	},
	watch: {
		gapRates: {
			handler: 'syncFromStore',
			deep: true
		}
	},
	created() {
		this.syncFromStore();
	}
};
</script>

<style scoped></style>
